// Thank-you popup + confetti burst on add-to-cart.
// Shows the popup first, then opens the cart drawer after a short
// delay so the "Thank You" moment isn't stepped on by the drawer.
// Listens for the theme's cart:update event and only fires when the
// update came from an actual add-to-cart action (product form or
// quick order list), not from cart drawer quantity/removal changes.
(function () {
if (window.__thankYouPopupInitialized) return;
window.__thankYouPopupInitialized = true;

var STYLE_ID = 'thank-you-popup-styles';
var ADD_SOURCES = ['product-form-component', 'quick-order-quantity'];
var POPUP_VISIBLE_MS = 1100;
var DRAWER_OPEN_DELAY_MS = 1250;

function injectStyles() {
if (document.getElementById(STYLE_ID)) return;
var style = document.createElement('style');
style.id = STYLE_ID;
style.textContent =
'.thank-you-popup-overlay{position:fixed;inset:0;display:flex;align-items:center;justify-content:center;pointer-events:none;z-index:99999;opacity:0;transition:opacity .25s ease;}' +
'.thank-you-popup-overlay.is-visible{opacity:1;}' +
'.thank-you-popup-card{background:#161616;border:3px solid #E4342F;border-radius:16px;padding:2.5rem 4rem;text-align:center;transform:scale(.6);transition:transform .4s cubic-bezier(.34,1.56,.64,1);box-shadow:0 20px 60px rgba(0,0,0,.6);}' +
'.thank-you-popup-overlay.is-visible .thank-you-popup-card{transform:scale(1);}' +
'.thank-you-popup-title{font-weight:800;font-size:2.75rem;letter-spacing:.02em;color:#fff;margin:0;text-transform:uppercase;}' +
'.thank-you-popup-subtitle{margin:.5rem 0 0;color:#E4342F;font-size:1rem;letter-spacing:.15em;text-transform:uppercase;font-weight:600;}' +
'@media (max-width:600px){.thank-you-popup-card{padding:2rem;}.thank-you-popup-title{font-size:2rem;}}';
document.head.appendChild(style);
}

function showPopup() {
injectStyles();
var overlay = document.querySelector('.thank-you-popup-overlay');
if (!overlay) {
overlay = document.createElement('div');
overlay.className = 'thank-you-popup-overlay';
overlay.innerHTML =
'<div class="thank-you-popup-card">' +
'<p class="thank-you-popup-title">Thank You!</p>' +
'<p class="thank-you-popup-subtitle">Added to your cart</p>' +
'</div>';
document.body.appendChild(overlay);
}

overlay.classList.add('is-visible');
window.clearTimeout(overlay.dataset.hideTimeout);
var timeoutId = window.setTimeout(function () {
overlay.classList.remove('is-visible');
}, POPUP_VISIBLE_MS);
overlay.dataset.hideTimeout = timeoutId;
}

function fireConfetti() {
if (typeof window.confetti !== 'function') return;
var colors = ['#E4342F', '#ffffff', '#B8241F'];
window.confetti({ particleCount: 120, spread: 80, startVelocity: 45, origin: { y: 0.6 }, colors: colors, zIndex: 100000 });
window.confetti({ particleCount: 60, angle: 60, spread: 60, origin: { x: 0, y: 0.7 }, colors: colors, zIndex: 100000 });
window.confetti({ particleCount: 60, angle: 120, spread: 60, origin: { x: 1, y: 0.7 }, colors: colors, zIndex: 100000 });
}

function openCartDrawer() {
var drawer = document.querySelector('cart-drawer-component');
if (drawer && typeof drawer.open === 'function') {
drawer.open();
}
}

function handleCartUpdate(event) {
var data = event.detail && event.detail.data;
if (!data || data.didError) return;
if (ADD_SOURCES.indexOf(data.source) === -1) return;
showPopup();
fireConfetti();
window.setTimeout(openCartDrawer, DRAWER_OPEN_DELAY_MS);
}

document.addEventListener('cart:update', handleCartUpdate);
})();
